import React from 'react';
import { Link } from 'react-router';
import { List, ListItem, Paper } from 'material-ui';

import CheckMarkIcon from 'material-ui/svg-icons/navigation/check';

const ImproveFeedContainer = ({ commentCount, postsCount, likesCount }) => {
  return (<Paper>
    <div>
      <h4 style={{ padding: '20px', margin: 0, textAlign: 'center' }}>Improve Your Feed</h4>
    </div>
    <hr />
    <List style={{ padding: '0 20px 20px 20px' }}>
      <ListItem disabled style={Object.assign({}, { fontSize: '14px', lineHeight: '16px' }, postsCount > 0 && { textDecoration: 'line-through', color: 'rgb(224, 224, 224)' })} primaryText="Make your first post" leftIcon={<CheckMarkIcon color={postsCount > 0 ? '#1cd81c' : 'rgb(224, 224, 224)'} />} />
      <ListItem style={{ fontSize: '14px', lineHeight: '16px' }} primaryText={<Link to="/connections/add-connections">Find your peers &amp; partners on TourConnect</Link>} leftIcon={<CheckMarkIcon color="rgb(224, 224, 224)" />} />
      <ListItem disabled style={Object.assign({}, { fontSize: '14px', lineHeight: '16px' }, likesCount > 4 && { textDecoration: 'line-through', color: 'rgb(224, 224, 224)' })} primaryText={`Like ${5 - likesCount > 0 ? 5 - likesCount : 5} more posts`} leftIcon={<CheckMarkIcon color={likesCount > 4 ? '#1cd81c' : 'rgb(224, 224, 224)'} />} />
      <ListItem disabled style={Object.assign({}, { fontSize: '14px', lineHeight: '16px' }, commentCount > 0 && { textDecoration: 'line-through', color: 'rgb(224, 224, 224)' })} primaryText="Make your first comment" leftIcon={<CheckMarkIcon color={commentCount > 0 ? '#1cd81c' : 'rgb(224, 224, 224)'} />} />
    </List>
  </Paper>);
};

export default ImproveFeedContainer;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/improveFeed/improveFeedContainer.jsx